<template>
<div id="container" class="dinowelt">
    <div class="fullscreen_background">
        <img src="/static/assets/dinowelt/Hintergrund_2860.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/dinowelt/Moeve.png" />
    </div> -->
<div class="z20 buecherstapel_one">
    <img class="img" src="/static/assets/dinowelt/Vektor-Smartobjekt.png" />
    </div>
  <div class="z20 buecherstapel_two">
    <img class="img" src="/static/assets/dinowelt/Vektor-Smartobjekt2.png" />
    </div>
    <div class="john z30">
        <!-- <img class="img" src="/static/assets/dinowelt/Schwimmer.png" /> -->
        <img class="img" src="/static/assets/dinowelt/Jonny_Palaeonetti.png" />
    </div>
  <div class="drohne z30">
        <!-- <img class="img" src="/static/assets/dinowelt/Schwimmer.png" /> -->
        <img class="img hovering1" src="/static/assets/dinowelt/Hugidubies_Website_Animation_3_Dinowelt_Drone2.png" />
    </div>
  <div class="queen z30">
        <!-- <img class="img" src="/static/assets/dinowelt/Schwimmer.png" /> -->
        <img class="img hovering2" src="/static/assets/dinowelt/animation_Queen.png" />
    </div>
    <div class="lianen_joe z30">
        <img class="img" src="/static/assets/dinowelt/Hudu_Hugidubies_Characters_Dinowelt_300ppi_6.png" />
    </div>
    <div class="manusaurus z30">
        <img class="img" src="/static/assets/dinowelt/animation_Manusaurus.png" />
    </div>
  <div class="libero_dino z30">
        <img class="img" src="/static/assets/dinowelt/Libero_dino.png" />
    </div>
    <div class="hugi z30">
        <img class="img" src="/static/assets/dinowelt/Hugi_trias.png" />
    </div>
	<div class="gigi z30">
        <img class="img" src="/static/assets/dinowelt/Gigi_Kreide.png" />
    </div>
    <div class="dubix z30">  
      <img class="img" src="/static/assets/dinowelt/Dubix_trias.png" />
    </div>
    <div class="biene z29">
      <img class="img hovering4" src="/static/assets/dinowelt/Biene_bitte_Schweben_Lassen.png" />
    </div>
	
    <router-link to="/escaperoom" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil.png" />
    </router-link>

    <router-link to="/eiswelt" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/dinowelt/Textfeld.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichten_Langsam_DubixJura.mp3" jsonurl="/static/assets/geschichten/dubix_ausgabe_6.json" content=".dinowelt" target="dinowelt_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="dinowelt_target">
        <p>Alle zwölf Jahre kehrt im Lauf der Zeiten das Jahr der Dinos wieder. Scheint dann der Vollmond ein siebtes Mal, begeben sich die DinofreundInnen Gigi Kreide, Hugi Trias, Dubix Jura und Libero Dino an einen geheimen, großen See, der Loch Lan heißt. Sie stellen sich auf einen der Hügel, der Loch Lan umsäumt, und blicken auf eine winzige Felsenspitze, die aus der Mitte des Sees ragt. Trifft diese der Mondstrahl, teilt sich das Wasser und mit lautem Getöse taucht der riesige Berg Mor empor und um ihn herum eine versunkene, uralte Landschaft: Dinotopia.</p>
<p>Die Hugidubies verfolgten staunend dieses einzigartige Schauspiel und warteten ungeduldig darauf, Dinotopia betreten zu können. Sie hatten nicht viel Zeit. Denn mit dem Mondlicht der nächsten Nacht würde die gerade aufgetauchte Landschaft wieder für zwölf Jahre versinken. Schwupp, schon stapften sie schwerbepackt mit Büchern über feuchte Schachtelhalme, zwischen tropfenden Riesenfarnen und unter triefenden Urwaldbäumen hindurch. Der Mond leuchtete ihnen den Weg und bei Sonnenaufgang gelangten sie auf die weite, gelbflimmernde Steppe, die sich unter dem Berg Mor ergoss. Dort fand alle zwölf Jahre das große geheime Dino-Lesefest statt, bei dem die Hugidubies nicht fehlen durften. Selbst die gefährlichsten unter den Dinos wie Tyrannos Minor waren an diesem Tag ganz friedlich.</p>
<p>Gigi Kreide, Hugi Trias, Dubix Jura und Libero Dino kletterten den Berg Mor hinauf, um später auch den größten Dinos auf Augenhöhe vorlesen zu können. „Sie kommen! Spürt ihr es auch?“, flüsterte Dubix Jura aufgeregt. Tatsächlich schien die Erde unter ihnen zu beben, so gewaltig waren die Körper und Tritte derer, die sich nun unter dem Berg Mor zu sammeln begannen: Plateosaurier, Tyrannosaurier, Diplodocen, Triceratopse und Brachiosaurier. „Sie sind so faszinierend!“, raunte Hugi Trias. Gigi Kreide nickte andächtig und winkte ihnen zu. Eilig begannen die Hugidubies ihre Bücher auszupacken, aus denen sie den Dinos vortragen wollten. Als Dubix Jura sein Buch aufschlug und gerade mit dem Vorlesen beginnen wollte, wurde der Steppensand plötzlich aufgewühlt. Maiasaurus Lu stürmte herbei und berichtete, ein fremder Flugsaurier bedrohe ihre Nester, obwohl heute Dino-Lesefest sei! Erschrocken baten die Hugidubies die Flugsaurierin Quetzalcoatlus Queen, sie schnell zu den Maiasaurusnestern zu bringen. Sie sprangen auf ihre Schwingen und hörten schon bald ein lautes Brummen: ein Hubschrauber! Und wer saß darin? Der berühmte Urzeitforscher Jonny Paläonetti! Er war ihnen also heimlich gefolgt und jetzt mussten sie mitansehen, wie er mit einer Greifzangendrohne Dino-Eier raubte! Die Maiasaurier fauchten und versuchten ihre Brut zu schützen, doch die Drohne war zu flink. Da hatte Dubix Jura die rettende Idee und erklärte Quetzalcoatlus Queen, was sie zu tun habe. Diese schwang sich daraufhin mit ihren riesigen Flügeln dicht über den Hubschrauber und zwang Jonny Paläonetti so zum Versammlungsort der Dinos.</p>
<p>Dort landete der Hubschrauber inmitten der riesigen Bewohner Dinotopias und reichte seinem Herrscher, Tyrannos Minor, gerade mal bis zur Fußkralle. Die Hugidubies landeten mit Quetzalcoatlus Queen ebenfalls, rannten zum Hubschrauber und rissen die Tür auf. Mit zittrigen Händen übergab Jonny Paläonetti Dubix Jura ein Maiasaurusei nach dem anderen.</p>
<p>Überglücklich nahmen die Maiasaurier sie entgegen.</p>
<p>Jonny Paläonetti aber wurde vor Tyrannos Minor geführt. Schlotternd und stotternd schwor er, niemals mehr nach Dinotopia zurückzukehren, niemandem davon zu berichten und nie wieder Dino-Eier zu stehlen. Dann zerstörte Tyrannos Minor mit einem Zehentritt seinen Hubschrauber und hieß Quetzalcoatlus Queen, ihn dorthin zu bringen, wo der Pfeffer wächst.</p>
<p>Danach aber taten die Dinos endlich das, worauf sie sich zwölf Jahre lang gefreut hatten: Sie ließen sich am Fuß des Berges Mor nieder und lauschten begeistert den Hugidubies, die ihnen die schönsten Dino- und Drachengeschichten vorlasen. Als es Abend wurde, nahmen alle traurig Abschied und Quetzalcoatlus Queen brachte die Hugidubies zurück auf den Hügel am Rande des Loch Lan. Gebannt sahen sie zu, wie Dinotopia verschwand, um im nächsten Dinojahr wieder aufzuerstehen. Quetzalcoatlus Queen aber spie zum Abschied Feuer und schrieb in Flammenschrift über die untergehende Sonne:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'dinowelt',
  data () {
    return {
      who: 'dinowelt'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2021_DubixJura.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Dubix_Jura_AtmoV2.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* dinowelt */
.dinowelt { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.dinowelt .himmel { display: block !important; }

.dinowelt .geschichte { position: absolute; top: 170px; left:51%;  }

.dinowelt .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.dinowelt .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* dinowelt .schwimmer {position: absolute; left: 28%; top: 39%; } */
.dinowelt .schwimmer {position: absolute; left: 25%; top: 12%; }
.dinowelt .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.dinowelt .fuchs_animation {
  width: 122px !important;
  height: 204px !important;
  background: url('/static/assets/dinowelt/Wassergeist_Animation.png') top center;
  animation: fuchs_animation 3s steps(15) infinite;
  animation-delay: 0.4s;
  transform: scale(1);
}
.dinowelt .baer {position: absolute; /* left: 36%; top: 74%; */ left: -474px; top: -299px;}
.dinowelt .baer {animation: baer_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes baer_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}

.dinowelt .gras {position: absolute; /* left:0; bottom: -5px;*/ left: -25%; bottom: -25%;}
.dinowelt .lianen_joe {position: absolute;
    left: 708px;
    bottom: 223px;}
.dinowelt .lianen_joe {animation: lianen_joe_erscheint 2s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes lianen_joe_erscheint {
    0% { transform: scale(0.7); opacity:1; left: 988px;}
    100% { transform: scale(1); opacity:1; left: 708px;}
}
.dinowelt .koechin {position: absolute; left: 37%; bottom: 26%;}
.dinowelt .hugi {position: absolute;
        right: 975px;
    bottom: 70px;}
.dinowelt .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .dinowelt .dubix {position: absolute; left: 645px;
    bottom: 165px;}
.dinowelt .dubix {animation: hugi_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  
.dinowelt .buecherstapel_one {
    position: absolute;
    top: 800px;
    left: 560px;
}  
.dinowelt .buecherstapel_two {
    position: absolute;
    bottom: 110px;
    right: 60px;
}
  
.dinowelt .Kolibri {position: absolute; right: -542px;
    bottom: -202px;}
/* .dinowelt .Kolibri {animation: schwimmen 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;} */
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .dinowelt .gigi {position: absolute; left: 528px; bottom: 343px;}
  .dinowelt .libero_dino {position: absolute; left: 458px; bottom: 243px; animation: dubix_erscheint 1s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
.dinowelt .gigi {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .dinowelt .manusaurus{
    position: absolute;
    top: -330px;
    left: -730px;
    animation: manusaurus_erscheint 5s ease-out; animation-delay: 1s; animation-fill-mode: forwards;
    opacity: 0;
  }
@keyframes manusaurus_erscheint {
  0% {
    top: -330px;
    left: -730px;
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  100% {
    top: -330px;
    left: -500px;
    opacity: 1;
  }
}  
.dinowelt .queen.z30 {
    position: absolute;
    top: -283px;
    left: -1203px;
    animation: queen_erscheint 5s ease-out; animation-delay: 1s; animation-fill-mode: forwards;
}  
@keyframes queen_erscheint {
  0% {
    top: -453px;
    left: -1203px;
  }
  100% {
    top: -283px;
    left: -443px;
  }
}  
.dinowelt .wasserfall {position: absolute; /* left: 23%; bottom: 6%; */}
.dinowelt .moeve { position: absolute; top: 250px; left: 600px; }
.dinowelt .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  25% {
    -ms-transform: translate(20px,30px);
    -moz-transform: translate(20px,30px);
    -webkit-transform: translate(20px,30px);
    -o-transform: translate(20px,30px);
    transform: translate(20px,30px);
  }
  50% {
    -ms-transform: translate(-10px,10px);
    -moz-transform: translate(-10px,10px);
    -webkit-transform: translate(-10px,10px);
    -o-transform: translate(-10px,10px);
    transform: translate(-10px,10px);
  }
  75% {
    -ms-transform: translate(-20px,-20px); 
    -moz-transform: translate(-20px,-20px); 
    -webkit-transform: translate(-20px,-20px);
    -o-transform: translate(-20px,-20px);
    transform: translate(-20px,-20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.dinowelt .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.dinowelt .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.dinowelt .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.dinowelt .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,10px);
    -moz-transform: translate(20px,10px);
    -webkit-transform: translate(20px,10px);
    -o-transform: translate(20px,10px);
    transform: translate(20px,10px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.dinowelt .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
.blubber.blubber_animation {
    top: -25%;
    left: -25%;
    position: absolute;
}
.dinowelt .john {
    position: absolute;
    top: 248px;
    left: 787px;
  animation: dubix_erscheint 1s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.dinowelt .drohne {
    position: absolute;
    top: -320px;
    left: -580px;
}

@keyframes blubber_animation {
    100% { background-position: 0 -9720px; }
}
.dinowelt .wassergeist {position: absolute; top: 871px; left: 10px;}
.wassergeist_animation {
  width: 122px;
  height: 204px;
  background: url('/static/assets/dinowelt/Wassergeist_Animation.png') top center;
  animation-delay: 1s;
  animation: wassergeist_animation 15s steps(15) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes wassergeist_animation {
    0% { background-position: 0 -0px; }
    10% { background-position: 0 -3060px; }
    100% { background-position: 0 -3060px; }
}	
span { font-family: FrozenMemory; } 
.player {
    position: absolute;
    top: 660px !important;
    left: 110px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dinowelt.vue